<template>
  <div class="h-screen w-screen flex flex-col overflow-hidden">
    <div class="h-10/100 w-full">
      <AdminUIHeader />
    </div>
    <div class="flex-grow overflow-scroll bg-backgroundOfForm">
      <div class="content">
        <div class="content-container">
          <div class="card-container">
            <h2>{{ t('admin-ui.welcome_on_admin_part') }}</h2>
            <div class="card-title">
              <h6>{{ t('admin-ui.click_on_card') }}</h6>
            </div>
            <div class="card-container">
              <span @click="$emit('clickOnSignUp', locale)">
                <div class="adminui-card">
                  <h1>{{ t('admin-ui.sign_up') }}</h1>
                  <p class="subtext">
                    {{ t('admin-ui.click_here_to_signup') }}
                  </p>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useI18n} from 'vue-i18n';
import HitSelect from '@hit/components/src/components/form/input/HitSelect.vue';
import AdminUIHeader from './header/AdminUIHeader.vue';
import MyFooter from './footer/MyFooter.vue';

export default defineComponent({
  name: 'WelcomePage',
  components: {MyFooter, AdminUIHeader, HitSelect},
  setup() {
    const {t, locale} = useI18n();
    return {t, locale};
  },
});
</script>
